<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <h4 class="card-title mb-4">
                  {{ GET_APPLICATION_SELECTED.name }} User View Permissions Setting
                </h4>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <b-form-group>
                  <button
                    v-if="!hasUserSelected"
                    :disabled="isLoadTreeModel && hasUserSelected"
                    @click="toggleSideBar = !toggleSideBar"
                    type="button"
                    class="btn btn-success waves-effect waves-light"
                  >
                    <i class="fa fa-search"></i>
                    Select user
                  </button>
                  <span v-if="hasUser" class="m-4 bold">
                    ({{ user.reference_id.crc_id }})
                    {{ user.info.first_name.th || user.info.first_name.en }}
                    {{ user.info.last_name.th || user.info.last_name.en }}
                    <button
                      @click="toggleSideBar = !toggleSideBar"
                      type="button"
                      class="btn btn-info btn-sm waves-effect waves-light ml-2"
                    >
                      Change user
                    </button>
                  </span>
                </b-form-group>
                <template v-if="hasTreeModel">
                  <vue-drag-tree
                    :data="treeModel"
                    :allowDrag="allowDrag"
                    :allowDrop="allowDrop"
                    :defaultText="'New Node'"
                    :displayCheckBox="displayCheckBox"
                    @current-node-clicked="curNodeClicked"
                    @drag="dragHandler"
                    @drag-enter="dragEnterHandler"
                    @drag-leave="dragLeaveHandler"
                    @drag-over="dragOverHandler"
                    @drag-end="dragEndHandler"
                    @drop="dropHandler"
                    @selectedCheckBox="selectedCheckBox"
                    v-if="userSelected !== null"
                  >
                  </vue-drag-tree>
                </template>
              </div>
              <div class="col-lg-8" v-if="viewIdSelected !== ''">
                <div class="row">
                  <div class="col-lg-10">
                    <h4 class="card-title mb-4">View: {{ displayName(viewObject) }}</h4>
                  </div>
                  <div class="col-lg-2"></div>
                  <div class="col-lg-12">
                    <b-form-checkbox
                      v-model="isMenuViewAble"
                      @change="menuViewAbleSelectChange"
                      class="custom-checkbox-success mb-3"
                      switch
                      size="lg"
                      >Menu view able</b-form-checkbox
                    >
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-sm-12 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length"></div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter text-md-right"
                        >
                          <label
                            class="d-inline-flex align-items-center"
                            style="min-width: 300px"
                          >
                            <b-form-input
                              v-model="filterPermission"
                              type="search"
                              placeholder="Search"
                              class="form-control form-control-sm ml-2"
                            ></b-form-input>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="table-responsive">
                          <b-table
                            class="table table-centered table-nowrap"
                            ref="usertable"
                            :empty-text="'Not found any result'"
                            :show-empty="!isViewObjectPermissions"
                            :bordered="true"
                            :filter="filterPermission"
                            :items="viewObjectPermissions"
                            align="center"
                            v-bind:fields="permissionTablefields"
                            :perPage="paginationPermission.pageSize"
                          >
                            <template v-slot:head(id)>
                              Select
                              <b-form-checkbox
                                v-show="isViewObjectPermissions"
                                v-model="selectAll"
                                @change="toggleSelectAll($event)"
                                class="custom-checkbox-info"
                              >
                              </b-form-checkbox>
                            </template>
                            <template v-slot:cell(id)="data">
                              <div class="text-center">
                                <b-form-checkbox
                                  v-model="data.item.selected"
                                  :true-value="true"
                                  :false-value="false"
                                  class="custom-checkbox-info mb-3"
                                  @change="permissionSelectChange(data.item)"
                                  checked
                                ></b-form-checkbox>
                              </div>
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 text-sm-right">
                        <div class="button-items">
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="updateViewPermision"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-center">
                <template v-if="isLoadTreeModel && !hasTreeModel">
                  <hr />
                  ไม่พบข้อมูลสิทธิ์ของแอปพลิเคชัน กรุณาเพิ่มข้อมูลสิทธิ์ก่อน
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <sideBar
        ref="sideBar"
        :toggleSideBar="toggleSideBar"
        @hidden="toggleSideBar = false"
        @setUserSelected="setUserSelected"
      ></sideBar>
    </div>
  </Layout>
</template>
<script>
import VueDragTree from "@/libs/vue-drag-tree/src/VueDragTree";
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import viewProvider from "@/helpers/service/view-provider";
import { applicationComputed } from "@/state/helpers";
import sideBar from "@/components/user-view-permission/sideBar";
import userService from "@/helpers/service/user-provider";
import userViewPermissionService from "@/helpers/service/user-view-permission-provider";
export default {
  components: {
    Layout,
    PageHeader,
    "vue-drag-tree": VueDragTree,
    sideBar,
  },
  data() {
    return {
      title: "User View Permissions",
      selectAll: false,
      items: [],
      users: [],
      treeModel: [],
      userSelected: null,
      user: {},
      paginationPermission: {
        totalRecords: 0,
        pageNo: 0,
        pageSize: 9999,
        totalPages: 0,
        hasPreviousPage: true,
        hasNextPage: true,
        items: [],
      },
      pageOptions: [5, 10, 25, 50, 100],
      permissionTablefields: [
        {
          key: "id",
          label: "Select",
          thStyle: "width:80px",
          class: "text-center",
          sortable: false,
        },
        {
          key: "display_name",
          label: "Display Name",
          sortable: true,
        },
        {
          key: "action",
          label: "Action Privilege",
          sortable: true,
        },
        {
          key: "controller",
          label: "Category",
          sortable: true,
        },
        {
          key: "version",
          label: "Version",
          sortable: true,
        },
      ],
      permissionSelected: [],
      filterPermission: "",
      displayCheckBox: false,
      toggleSideBar: false,
      viewIdSelected: "",
      viewObject: {
        permissions: [],
      },
      viewObjectPermissions: [],
      viewPermissions: [],
      isMenuViewAble: false,
      isLoadTreeModel: false,
    };
  },
  async mounted() {
    this.isLoadTreeModel = false;
    await this.getTreeModel();
  },
  computed: {
    ...applicationComputed,
    hasUser() {
      return this.$validate.isObjectValid(this.user);
    },
    hasUserSelected() {
      return this.$validate.isObjectValid(this.userSelected);
    },
    hasTreeModel() {
      return this.$validate.anyArrayObjectValid(this.treeModel);
    },
    isViewObjectPermissions() {
      return this.$validate.anyArrayObjectValid(this.viewObjectPermissions);
    },
  },
  watch: {
    userSelected: {
      async handler(val) {
        if (val !== null) await this.getUserById();
      },
      deep: true,
    },
  },
  methods: {
    toggleSelectAll(newVal) {
      // this.viewObjectPermissions.forEach((element) => {
      //   element.selected = newVal;
      // });
      this.viewObjectPermissions = this.viewObjectPermissions.map(item => ({
      ...item,
      selected: newVal
    }));

      this.$nextTick(() => {
        if (newVal) {
          this.isMenuViewAble = true;
        } else {
          this.isMenuViewAble = false;
        }
      });
    },
    displayName(item) {
      if (this.$validate.isObjectValid(item.display_name)) {
        if (this.$validate.isTrimValid(item.display_name.en)) {
          return item.display_name.en;
        } else if (this.$validate.isTrimValid(item.display_name.th)) {
          return item.display_name.th;
        }
      }
      return item.view_name;
    },
    permissionSelectChange() {
      this.viewObjectPermissions = this.viewObjectPermissions.map((element) => {
        return Object.assign({}, element);
      });

      this.$nextTick(() => {
        this.isMenuViewAble = this.viewObjectPermissions.some((q) => q.selected);

        if (this.isViewObjectPermissions) {
          this.selectAll = this.viewObjectPermissions.every((q) => q.selected);
        } else {
          this.selectAll = false;
        }
      });
    },
    menuViewAbleSelectChange(val) {
      if (!val) {
        this.viewObjectPermissions = this.viewObjectPermissions.map((element) => {
          element.selected = false;
          return Object.assign({}, element);
        });
        this.selectAll = false

      }
    },
    async setUserSelected(userId) {
      this.userSelected = userId;
      this.toggleSideBar = false;
    },
    async getUserById() {
      let result = await userService.getUserAsync(this.userSelected);
      if (result.status === 200) {
        //  console.log("result user by id", result.data);
        this.user = result.data;
        if (this.$validate.anyArrayObjectValid(result.data.applications)) {
          let applicationSelect = result.data.applications.filter(
            (q) => q.id === this.GET_APPLICATION_SELECTED.id
          );
          if (applicationSelect && applicationSelect.length) {
            this.viewPermissions = applicationSelect[0].views;
          }
          // console.log("viewPermissions", this.viewPermissions);
        }
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async getTreeModel() {
      let params = new URLSearchParams();
      params.append("no-cache", 1);
      let result = await viewProvider.getViewAsync(
        this.GET_APPLICATION_SELECTED.id,
        params
      );
      // console.log("result", result);
      if (result.status === 200) {
        if (this.$validate.anyArrayObjectValid(result.data)) this.treeModel = result.data;
      }
      this.isLoadTreeModel = true;
    },
    async getViewById(viewId, isNoCache) {
      let params = new URLSearchParams();
      if (isNoCache) params.append("no-cache", 1);
      let result = await viewProvider.getViewByIdAsync(
        this.GET_APPLICATION_SELECTED.id,
        viewId,
        params
      );
      //   console.log("result", result);
      if (result.status === 200) {
        this.viewObject = result.data;
        this.viewObjectPermissions = this.viewObject.permissions;
        if (this.$validate.anyArrayObjectValid(this.viewObjectPermissions)) {
          this.viewObjectPermissions.forEach((permission) => {
            permission.selected = false;
            if (this.$validate.anyArrayObjectValid(this.viewPermissions)) {
              this.viewPermissions.forEach((viewPermission) => {
                if (
                  this.$validate.anyArrayObjectValid(viewPermission.permissions) &&
                  this.viewObject.view_id === viewPermission.id
                ) {
                  permission.selected =
                    viewPermission.permissions.find((q) => q.id === permission.id) !==
                    undefined;
                }
              });
            }
          });
          
          this.selectAll = this.viewObjectPermissions.every((q) => q.selected);
        }
      }
    },
    async updateViewPermision() {
      if (
        this.$validate.anyArrayObjectValid(this.viewObjectPermissions) ||
        this.isMenuViewAble
      ) {
        let apiData = {};
        if (this.$validate.anyArrayObjectValid(this.viewObjectPermissions)) {
          let selectedList = this.viewObjectPermissions.filter((q) => q.selected);
          apiData = {
            permissions: selectedList.map((q) => q.id),
          };
        }

        //  console.log("apiData", apiData);
        let result = await userViewPermissionService.updateUserViewPermission(
          this.GET_APPLICATION_SELECTED.id,
          this.userSelected,
          this.viewObject.id,
          apiData
        );
        //    console.log("this.isMenuViewAble", this.isMenuViewAble);
        if (result.status === 204) {
          // this.isMenuViewAble = false;
          this.$utils.notification("success", "Update success", 1500);
          await this.getUserById();
        }
      } else if (!this.isMenuViewAble) {
        let result = await userViewPermissionService.deleteUserViewPermission(
          this.GET_APPLICATION_SELECTED.id,
          this.userSelected,
          this.viewObject.id
        );
        if (result.status === 200) {
          // this.isMenuViewAble = false;
          this.$utils.notification("success", "Update success", 1500);
          await this.getUserById();
        }
      }
    },
    allowDrag(model, component) {
      // if (model.name === "Node 0-1") {
      //   // can't be dragged
      //   return false;
      // }
      // // can be dragged
      // return true;
      return false;
    },
    allowDrop(model, component) {
      // if (model.name === "Node 2-2") {
      //   // can't be placed
      //   return false;
      // }
      // // can be placed
      // return true;
      return false;
    },
    selectedCheckBox(event, model) {
      // console.log("event", event.target.checked);
      // console.log("model", model);
    },
    async curNodeClicked(model, component) {
      // console.log("curNodeClicked", model, component);
      this.viewIdSelected = model.view_id;
      this.permissionSelected = [];
      if (model.view_id !== null) {
        await this.getViewById(model.view_id, true);
      }

      if (this.$validate.anyArrayObjectValid(this.viewPermissions)) {
        var x = this.viewPermissions.find((p) => p.id == model.view_id);
        this.isMenuViewAble = x ? true : false;
      } else {
        this.isMenuViewAble = false;
      }
    },
    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    },
  },
};
</script>
